<span class="mat-select-error">
  <mat-icon class="material-icons mat-select-error__icon">error_outline</mat-icon>
  <ng-content></ng-content>
</span>
